import React, {useEffect} from 'react'
import ModalPop from '../modal/modal';

const HtmlFailedModal = (
    {
        isOpen = false,
        msg="Something Went Wrong!",
        countToOpenModal=0,
        url='',
        handleModalHide,
    }
) => {

    const [modalIsOpen, setIsOpen] = React.useState(false);
    useEffect(() => {
        setIsOpen(isOpen)
    }, [isOpen, countToOpenModal])


    function closeModal() {
        setIsOpen(false);
        // window.location.reload()
        // window.location.href = window.localStorage.redirect_url
        // if(url !== ''){
        //     window.location.replace(url);
        // }
    }
    return (
        <>
            <ModalPop
                title='Alert'
                show={modalIsOpen}
                handleModalHide={closeModal}
                handleModalHide={handleModalHide||closeModal}
                keyboard
                backdrop
                url={url}
            >
                <div className="text-center">
                    <div className="success">
                        <img src="./img/error.gif" width="50%" alt="" />
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: msg }} />
                </div>
            </ModalPop>
        </>
    )
}

export default HtmlFailedModal